<div class="flex">
  <p-button
    label="Filters"
    class="flex"
    variant="text"
    severity="contrast"
    [disabled]="disabled() || !filters?.length"
    (onClick)="filterPopover.toggle($event)"
  >
    <svg-icon src="/assets/icons/general/filter.svg" />
  </p-button>

  <p-popover
    #filterPopover
    (onHide)="onMenuClose()"
    (onShow)="onMenuOpen()"
    styleClass="[&_.p-popover-content]:p-0!"
  >
    <div class="w-80 p-3">
      <p class="p-2 pr-12! font-semibold">Select filters to apply</p>

      <div class="mb-2 ml-1 mr-3">
        <ag1-list-search
          [keys]="['name']"
          [items]="filters"
          placeholder="Search Filters"
          (filteredItemEvent)="filteredFilters = $event"
        />
      </div>

      <div class="grid max-h-64 grid-cols-1 overflow-y-auto px-1.5">
        @for (filter of filteredFilters; track filter.name) {
          <ag1-filter
            [filter]="filter"
            [appliedFilters]="appliedFilters"
            [disabled]="
              $safeNavigationMigration(disableFilters()?.includes(filter.name))
            "
            [showPresetSelection]="showDateSelectionPreset()"
          />
        }
      </div>

      <!-- filter controls -->
      <div class="mt-2 flex justify-end gap-2">
        <p-button
          size="small"
          variant="text"
          severity="contrast"
          (click)="clearAppliedFilters()"
          label="Clear Filters"
        />
        <p-button
          size="small"
          (click)="applyFilters()"
          label="Apply Filters"
          [pTooltip]="filterRequirementsUnmet() ? 'Required Filters Unset' : ''"
          [disabled]="
            disabled() || !filters?.length || filterRequirementsUnmet()
          "
        />
      </div>

      <p-button
        variant="text"
        severity="contrast"
        size="small"
        pTooltip="Close"
        tooltipPosition="left"
        class="absolute right-1 top-2"
        (click)="closeFilters()"
      >
        <ng-template #icon>
          <svg-icon src="/assets/icons/general/close.svg" />
        </ng-template>
      </p-button>
    </div>
  </p-popover>
</div>
